var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mub-wrapper",class:{'w-100 h-100': !_vm.blockItem && _vm.fullMub},attrs:{"data-mub":_vm.mubData}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }